import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+BI+Digital+Card+Number+API

function getBiDigitalCardNumber(userProfileId) {
    let url = `/api/bi/profiles/${userProfileId}/digitalCardNumber?source=other`;
    const { enableProfileBIGroup = false } = Sephora.configurationSettings;

    if (enableProfileBIGroup && cookieUtils.isRCPSProfileBiGroupAPIEnabled()) {
        url = `/gway/v2/bi/profiles/${userProfileId}/digitalCardNumber?source=other`;
    }

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default getBiDigitalCardNumber;
